<!--  -->
<template>
  <div class="topTitle" :style="{ color: color }">
    中华英烈网 <strong>·</strong> 纪念祭扫
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    color: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.topTitle {
  width: 500px;
  height: 50px;
  position: absolute;
  left: 100px;
  top: 50px;
  font-size: 25px;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/components/topTitle.vue